import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageSrcService {

  private dom = inject(DOCUMENT);

  update(url: string) {
    let el = this.dom.querySelector(`link[rel="image_src"]`) as HTMLLinkElement | null;
    if (!el) {
      el = this.dom.createElement('link');
      el.setAttribute('rel', 'image_src');
      this.dom.head.appendChild(el);
    }
    el.setAttribute('href', url);
  }
}
